"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _meterReading = _interopRequireDefault(require("./meterReading"));
var _registrationReducer = _interopRequireDefault(require("../../common/features/Registration/registrationReducer"));
var _accountData = _interopRequireDefault(require("../../common/features/AccountData/redux/accountData"));
var _contactLoggedIn = _interopRequireDefault(require("./contactLoggedIn"));
var _contracts = _interopRequireDefault(require("./contracts"));
var _search = _interopRequireDefault(require("../../csc/redux/search"));
var _loggedinMeterReading = _interopRequireDefault(require("./loggedinMeterReading"));
var _invoice = _interopRequireDefault(require("./invoice"));
var _meterPins = _interopRequireDefault(require("./meterPins"));
var _postboxReducer = _interopRequireDefault(require("../../common/features/PostBox/redux/postboxReducer"));
var _personalData = _interopRequireDefault(require("./personalData"));
var _budgetBillingPlan = _interopRequireDefault(require("./budgetBillingPlan"));
var _consumptionSubscription = _interopRequireDefault(require("./consumptionSubscription"));
var _contractConsumptions = _interopRequireDefault(require("./contractConsumptions"));
var _rlm = _interopRequireDefault(require("./rlm"));
var _devices = _interopRequireDefault(require("./devices"));
var _phone = _interopRequireDefault(require("./phone"));
var _myAppointment = _interopRequireDefault(require("./myAppointment"));
var _communication = _interopRequireDefault(require("./communication"));
var _taxNumbers = _interopRequireDefault(require("./taxNumbers"));
var _intermediateReadingReducer = _interopRequireDefault(require("../../common/features/IntermediateReading/intermediateReadingReducer"));
var reducers = {
  accountData: _accountData.default,
  budgetbillingplans: _budgetBillingPlan.default,
  consumptionSubscription: _consumptionSubscription.default,
  devices: _devices.default,
  invoice: _invoice.default,
  loggedInMeterReading: _loggedinMeterReading.default,
  communication: _communication.default,
  contractConsumptions: _contractConsumptions.default,
  contact: _contactLoggedIn.default,
  contracts: _contracts.default,
  meterPins: _meterPins.default,
  meterReading: _meterReading.default,
  myAppointment: _myAppointment.default,
  myData: _personalData.default,
  phone: _phone.default,
  postbox: _postboxReducer.default,
  registration: _registrationReducer.default,
  rlm: _rlm.default,
  search: _search.default,
  taxNumbers: _taxNumbers.default,
  intermediateReading: _intermediateReadingReducer.default
};
var _default = exports.default = reducers;